import React, { useCallback, useEffect } from 'react';
import ReactSVG from 'react-svg';
import times from 'times.svg';
import email from 'email.svg';
import CopyLink from './CopyLink';

export default function ShareModal({ subject, body, copyLink }) {
  const { disableBodyScroll, clearAllBodyScrollLocks } = window.bodyScrollLock;

  const toggleShareListing = useCallback(
    e => {
      e.stopImmediatePropagation();
      e.preventDefault();
      const share_modal_container = $('#share_modal_container');

      share_modal_container.toggleClass('hidden');

      if (share_modal_container.hasClass('hidden')) {
        clearAllBodyScrollLocks();
        $('body').css('overflow', '');
      } else {
        disableBodyScroll(share_modal_container);
      }
    },
    [clearAllBodyScrollLocks, disableBodyScroll]
  );

  useEffect(() => {
    const share_button = $('.share_listing');
    const share_modal_backdrop = $('#share_modal_backdrop');
    const close_modal = $('.close-modal.share');
    // Show share listing modal
    share_button.on('click', toggleShareListing);
    // Hide share listing modal
    share_modal_backdrop.on('click', toggleShareListing);
    close_modal.on('click', toggleShareListing);
  }, [toggleShareListing]);

  return (
    <modal id="share_modal_container" className="modal-container hidden">
      <div id="share_modal_backdrop" className="modal-backdrop" />

      <div className="modal modal-mini share-modal">
        <button
          name="Close Modal"
          aria-label="Close Modal"
          className="close-modal share"
          type="button"
        >
          <ReactSVG src={times} />
        </button>
        <h3 className="share-modal-title">Share</h3>
        <p className="share-modal-desc">
          Share this listing with your friends!
        </p>
        <ul className="share-modal-options">
          <a
            href={`mailto:?subject=${subject}&body=${body}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <li>
              <ReactSVG src={email} svgClassName="lazyload" />
              <span>Email</span>
            </li>
          </a>

          <CopyLink copyLink={copyLink} />
        </ul>
      </div>
    </modal>
  );
}
